import { render, staticRenderFns } from "./commonTitle.vue?vue&type=template&id=30c562fc&scoped=true"
import script from "./commonTitle.vue?vue&type=script&lang=js"
export * from "./commonTitle.vue?vue&type=script&lang=js"
import style0 from "./commonTitle.vue?vue&type=style&index=0&id=30c562fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c562fc",
  null
  
)

export default component.exports